import { callExternalApi } from "./external-api.service";

const tlogApiServerUrl = process.env.REACT_APP_TLOG_API_SERVER_URL;

export const setPlayerBidResource = async (clubId, playerId, amount, playerName, position, teamName) => {
  const config = {
    url: `${tlogApiServerUrl}/api/place-bid`,
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    data: {clubId:clubId, playerId:playerId, amount:amount, playerName:playerName, position:position, teamName:teamName}
  };
  
  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const getAllBidsCurrentPhaseResource = async () => {
  const config = {
    url: `${tlogApiServerUrl}/api/get-bids/currentPhase`,
    method: "GET",
    headers: {
      "content-type": "application/json"
    }
  };
  
  const { data, error } = await callExternalApi({ config });

  return {
    data: data.Items || null,
    error,
  };
};

export const updateBidStatusResource = async (bidId, winPhase, status) => {
  const config = {
    url: `${tlogApiServerUrl}/api/update-bid`,
    method: "POST",
    headers: {
      "content-type": "application/json"
    },
    data: { bidId, winPhase, status }
  };
  
  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};

export const confirmTeamResource = async (clubId, windowId, playerIds) => {

const config = {
  url: `${tlogApiServerUrl}/api/confirm-team/set`,
  method: "POST",
  headers: {
    "content-type": "application/json",
  },
  data: { clubId, windowId, team: playerIds },
};

const { data, error } = await callExternalApi({ config });

return {
  data: data || null,
  error,
};
};

export const getConfirmedTeamResource = async (clubId, windowId) => {
  const config = {
    url: `${tlogApiServerUrl}/api/confirm-team/get`,
    method: "POST",
    headers: {
      "content-type": "application/json",
    },
    data: { clubId, windowId },
  };

  const { data, error } = await callExternalApi({ config });

  return {
    data: data || null,
    error,
  };
};